import { useSelector } from 'react-redux';

import { customerSelector } from '@/api/v1';
import { Customer } from '@/types/customer';

export const useCustomer = (): Customer => {
  const { data: beneficiary = Customer.empty() } = useSelector(customerSelector);
  return beneficiary;
};
